import { Component, OnInit } from '@angular/core';
import { ToastController } from '@ionic/angular';
import { RouterInfoService } from '../services/router-info.service';

@Component({
  selector: 'app-my-wifi',
  templateUrl: './my-wifi.component.html',
  styleUrls: ['./my-wifi.component.scss'],
})
export class MyWifiComponent implements OnInit {
  loading = false;
  saving = false;
  applicable = true;
  reason = '';
  onuName = '';
  ports: any[] = [];
  edit: { [port: string]: { ssid: string; password: string; show: boolean } } = {};
  
  constructor(
    private wifi: RouterInfoService,
    private toast: ToastController,
  ) {}

  ngOnInit() { this.load(); }

  load() {
    
    this.loading = true;
    this.wifi.getWifiPorts().subscribe(
      (res) => {
        this.loading = false;
        this.applicable = res.applicable;
        this.reason = res.reason || '';
        this.onuName = res.onu_name || '';
        this.ports = res.wifi_ports || [];
        // inside load() success handler, alongside the existing assignments:
      this.onuStatus = res.onu_status || '';
      this.signalQuality = res.signal_quality || '';

        this.edit = {};
        for (const p of this.ports) {
          this.edit[p.wifi_port] = {
            ssid: p.ssid || '',
            password: p.password || '',   // prefilled if Smart OLT returns it
            show: false,
          };
        }
      },
      async (err) => {
        this.loading = false;
        await this.presentToast(err?.error?.detail || 'Could not load WiFi settings.');
      }
    );
  }

  async save(port: any) {
    const m = this.edit[port.wifi_port];
    if (!m.ssid?.trim()) { return this.presentToast('Network name cannot be empty.'); }
    if (m.password.length < 8 || m.password.length > 63) {
      return this.presentToast('Password must be 8–63 characters.');
    }

    this.saving = true;
    this.wifi.setWifi({
      wifi_port: port.wifi_port,
      ssid: m.ssid.trim(),
      password: m.password,
      authentication_mode: port.authentication_mode || 'WPA2',
      dhcp: port.dhcp || 'No control',
    }).subscribe(
      async (res) => {
        this.saving = false;
        await this.presentToast(res?.detail || 'WiFi updated.');
        this.load();
      },
      async (err) => {
        this.saving = false;
        await this.presentToast(err?.error?.detail || 'Update failed.');
      }
    );
  }

  toggleShow(port: any) {
    this.edit[port.wifi_port].show = !this.edit[port.wifi_port].show;
  }

  async presentToast(message: string) {
    const t = await this.toast.create({ message, duration: 2500, position: 'bottom' });
    await t.present();
  }
  onuStatus = '';
signalQuality = '';

get isOnline(): boolean {
  return (this.onuStatus || '').toLowerCase() === 'online';
}


// friendly label so customers never see "wifi_0/1" as a headline
friendlyName(port: any, index: number): string {
  if (this.ports.length === 1) { return 'Your WiFi'; }
  return `Network ${index + 1}`;
}
}